import type { Portfolio } from '@/hooks/portfolio/usePortfolio';
import { useBraze } from '@components/Braze';
import { useMount } from '@simplywallst/ui-core';

export const BrazeLogPortfolioVisit = ({
  portfolio,
}: {
  portfolio: Portfolio;
}) => {
  const { logCustomEvent } = useBraze();

  useMount(() => {
    logCustomEvent('portfolio_visit', {
      portfolioId: portfolio.id,
      portfolioName: portfolio.name,
    });
  });

  return null;
};
